// TODO: Dark mode
export const HistoryCheckIcon = () => {
  return (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24.2188C0 10.9639 10.7452 0.21875 24 0.21875C37.2548 0.21875 48 10.9639 48 24.2188C48 37.4736 37.2548 48.2188 24 48.2188C10.7452 48.2188 0 37.4736 0 24.2188Z"
        fill="#ECFDF5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.2188C17.9249 13.2188 13 18.1436 13 24.2188C13 30.2938 17.9249 35.2188 24 35.2188C30.0751 35.2188 35 30.2938 35 24.2188C35 18.1436 30.0751 13.2188 24 13.2188ZM29.2071 21.9259C29.5976 21.5353 29.5976 20.9022 29.2071 20.5116C28.8166 20.1211 28.1834 20.1211 27.7929 20.5116L22.5 25.8046L20.2071 23.5117C19.8166 23.1212 19.1834 23.1212 18.7929 23.5117C18.4024 23.9022 18.4024 24.5353 18.7929 24.9258L21.7929 27.9258C22.1834 28.3163 22.8166 28.3163 23.2071 27.9258L29.2071 21.9259Z"
        fill="#10B981"
      />
    </svg>
  )
}
